export const TitleNumber = ({ n }: { n: number }) => {
  switch (n) {
    case 1:
      return (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 156.5 156.5">
          <g>
            <g>
              <path
                fill="none"
                d="M78.2,14.5c-35.2,0-63.8,28.6-63.8,63.8c0,35.2,28.6,63.8,63.8,63.8S142,113.4,142,78.3 C142,43.1,113.4,14.5,78.2,14.5z"
              />
              <path d="M78.2,0.3c-43,0-78,35-78,78s35,78,78,78s78-35,78-78S121.2,0.3,78.2,0.3z M78.2,142c-35.2,0-63.8-28.6-63.8-63.8 c0-35.2,28.6-63.8,63.8-63.8S142,43.1,142,78.3C142,113.4,113.4,142,78.2,142z" />
            </g>
            <g>
              <path d="M95.6,112.1H62.7V108c1.6-0.7,3.2-1.3,4.8-1.9c1.6-0.5,3.2-1,4.9-1.4V61.1l0.4-5.6c-1.8,0.6-3.6,1-5.5,1.1 c-1.9,0.2-3.9,0.3-5.9,0.2l-0.5-3.5c3.4-0.9,7-2.1,11-3.6c4-1.5,7.6-3.3,11-5.3h3.2v60.3c1.6,0.4,3.2,0.8,4.8,1.4 c1.6,0.5,3.2,1.2,4.8,1.9V112.1z" />
            </g>
          </g>
        </svg>
      );
    case 2:
      return (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 156.5 156.5">
          <g>
            <path
              fill="none"
              d="M78.2,14.5c-35.2,0-63.8,28.6-63.8,63.8c0,35.2,28.6,63.8,63.8,63.8S142,113.4,142,78.3 C142,43.1,113.4,14.5,78.2,14.5z"
            />
            <path d="M78.2,0.3c-43,0-78,35-78,78s35,78,78,78s78-35,78-78S121.2,0.3,78.2,0.3z M78.2,142c-35.2,0-63.8-28.6-63.8-63.8 c0-35.2,28.6-63.8,63.8-63.8S142,43.1,142,78.3C142,113.4,113.4,142,78.2,142z" />
          </g>
          <g>
            <path d="M65.8,66.7h-3.2c-0.4-1-0.8-2.1-1.3-3.3c-0.5-1.3-1-2.6-1.5-4c-0.5-1.4-1-2.8-1.4-4.1c-0.4-1.4-0.8-2.6-1-3.8 c2.2-1.9,5-3.5,8.5-4.9c3.5-1.4,7.6-2.1,12.6-2.1c3.5,0,6.5,0.4,9,1.3c2.5,0.9,4.6,2.1,6.3,3.7c1.7,1.6,2.9,3.4,3.7,5.5 s1.2,4.3,1.2,6.7c0,3.9-0.9,7.5-2.7,11c-1.8,3.5-4,6.7-6.6,9.7c-2.6,3-5.4,5.8-8.4,8.4c-3,2.6-5.7,4.9-8.1,7l-4.9,3.3v0.4l5.8-0.6 h16.3l4.7-10.6h3.2c0.2,1.5,0.4,3.3,0.6,5.3c0.2,2,0.4,4.1,0.6,6.1c0.2,2.1,0.3,4,0.5,5.9c0.1,1.9,0.2,3.4,0.2,4.5H56.5V106 c1.6-1.5,3.5-3.1,5.6-5.1c2.1-1.9,4.2-4.1,6.4-6.4c2.2-2.3,4.3-4.8,6.4-7.4s4-5.2,5.6-7.9c1.6-2.7,3-5.4,3.9-8.2 c1-2.8,1.5-5.5,1.5-8.2c0-3.5-0.9-6.3-2.8-8.5c-1.9-2.2-4.5-3.3-7.9-3.3c-1.1,0-2,0.1-2.9,0.2c-0.9,0.1-1.8,0.3-2.9,0.7L65.8,66.7z " />
          </g>
        </svg>
      );
    case 3:
      return (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 156.5 156.5">
          <g>
            <path
              fill="none"
              d="M78.2,14.5c-35.2,0-63.8,28.6-63.8,63.8c0,35.2,28.6,63.8,63.8,63.8S142,113.4,142,78.3 C142,43.1,113.4,14.5,78.2,14.5z"
            />
            <path d="M78.2,0.3c-43,0-78,35-78,78s35,78,78,78s78-35,78-78S121.2,0.3,78.2,0.3z M78.2,142c-35.2,0-63.8-28.6-63.8-63.8 c0-35.2,28.6-63.8,63.8-63.8S142,43.1,142,78.3C142,113.4,113.4,142,78.2,142z" />
          </g>
          <g>
            <path d="M75.5,104.9c1.4,0,2.8-0.3,4.1-1c1.3-0.6,2.5-1.5,3.6-2.7c1.1-1.2,1.9-2.5,2.6-4.1c0.6-1.6,1-3.3,1-5.1 c0-2.1-0.4-3.9-1.1-5.4c-0.7-1.5-1.6-2.7-2.7-3.7c-1.1-1-2.4-1.7-3.9-2.2c-1.5-0.5-2.9-0.7-4.4-0.7h-5.3v-3.7l13.7-18l3.1-3.2v-0.4 l-4.9,0.5H67.4l-3.6,9.3h-3.1c-0.3-1.3-0.6-2.8-1-4.6c-0.3-1.8-0.6-3.5-0.9-5.3c-0.3-1.8-0.5-3.5-0.6-5.1c-0.2-1.6-0.2-3-0.2-4.1 h40v4.5L82.1,69.5l-3.9,4v0.2l3.1-0.6c2.9,0.1,5.5,0.7,7.7,1.6c2.3,0.9,4.2,2.2,5.8,3.8c1.6,1.6,2.7,3.5,3.6,5.6 c0.8,2.1,1.2,4.5,1.2,7.1c0,3.1-0.7,5.8-2,8.2c-1.3,2.4-3.1,4.5-5.3,6.2c-2.2,1.7-4.8,3-7.7,3.9c-2.9,0.9-6,1.3-9.3,1.3 c-1.8,0-3.7-0.1-5.5-0.4c-1.8-0.3-3.6-0.7-5.2-1.1c-1.6-0.5-3.1-1.1-4.4-1.7c-1.3-0.7-2.4-1.4-3.3-2.2l3.4-9.5H63 c0.4,0.4,0.9,1,1.5,1.7c0.6,0.7,1.3,1.5,2,2.2c0.7,0.8,1.4,1.6,2.1,2.4c0.7,0.8,1.3,1.5,1.7,2c0.6,0.1,1.3,0.3,2.1,0.5 C73.1,104.8,74.2,104.9,75.5,104.9z" />
          </g>
        </svg>
      );
    case 4:
      return (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 156.5 156.5">
          <g>
            <path
              fill="none"
              d="M78.2,14.5c-35.2,0-63.8,28.6-63.8,63.8c0,35.2,28.6,63.8,63.8,63.8S142,113.4,142,78.3 C142,43.1,113.4,14.5,78.2,14.5z"
            />
            <path d="M78.2,0.3c-43,0-78,35-78,78s35,78,78,78s78-35,78-78S121.2,0.3,78.2,0.3z M78.2,142c-35.2,0-63.8-28.6-63.8-63.8 c0-35.2,28.6-63.8,63.8-63.8S142,43.1,142,78.3C142,113.4,113.4,142,78.2,142z" />
          </g>
          <g>
            <path d="M96.8,112.7H66.9v-4.2c3.2-1.1,6.1-1.9,8.9-2.3V95.3H47.2v-4.3l37-47.1h5.2V89h11.9v6.3H89.4v10.9c2.5,0.5,5,1.3,7.3,2.3 V112.7z M75.8,68.4l1-6.8h-0.3l-3.7,6.8l-14,18.1l-3.9,3.2l6.9-0.7h14V68.4z" />
          </g>
        </svg>
      );
    default:
      return <></>;
  }
};
